// eslint-disable-next-line import/prefer-default-export
export const storage = {
  set(key: string, value: unknown, session = false) {
    const storageType = session ? window.sessionStorage : window.localStorage;
    if (value) {
      storageType.setItem(key, JSON.stringify({ data: value }));
    } else {
      storage.remove(key, session);
    }
  },
  get(key: string, session = false) {
    const storageType = session ? window.sessionStorage : window.localStorage;
    const item = storageType.getItem(key);
    return item ? JSON.parse(item).data : null;
  },
  remove(key: string, session = false) {
    const storageType = session ? window.sessionStorage : window.localStorage;
    storageType.removeItem(key);
  },
  clear(session = false) {
    const storageType = session ? window.sessionStorage : window.localStorage;
    storageType.clear();
  },
};
